import { css } from "@emotion/react";
import { bpoints } from "../../../../Utils";

export function carDataFormCSS() {
    return css`
        display: flex;
        flex-direction: column;
        align-items: center;
        z-index: 1;
        position: relative;

        .MainContainer {
            width: 100%;
            padding: 2.5rem 0 5rem;
            position: relative;
        }

        .LayoutShell {
            width: min(920px, 90%);
            margin: 0 auto;
            position: relative;
            z-index: 1;
        }

        .ContentColumn {
            display: flex;
            flex-direction: column;
            gap: 1.75rem;
        }

        .HeroCard,
        .FormCard,
        .SummaryCard {
            border-radius: 28px;
            background: rgba(255, 255, 255, 0.73);
            box-shadow: 2px 2px 11px rgba(33, 88, 140, 0.04);
            backdrop-filter: blur(5px);
        }

        .HeroCard {
            padding: 1.25rem 2rem;
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }

        .HeroEyebrow,
        .SectionEyebrow,
        .SummaryEyebrow,
        .SummaryPlate {
            color: #22a37e;
            font-size: 0.85rem;
            letter-spacing: 0.14em;
            font-weight: 700;
            text-transform: uppercase;
        }

        .HeroCopy {
            display: flex;
            flex-direction: column;
            gap: 0.75rem;
        }

        .Title {
            margin: 0;
            color: #21588C;
            font-weight: 700;
            line-height: 1.05;
            font-size: clamp(2rem, 1.2rem + 2vw, 3.3rem);
        }

        .TitleCompact {
            font-size: clamp(1.4rem, 1rem + 1.2vw, 2rem);
        }

        .HeroDescription {
            margin: 0;
            max-width: 760px;
            color: #587183;
            font-size: 1rem;
            line-height: 1.65;
        }

        .HeroInputs {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 1rem;
        }

        .HeroInput,
        .Field {
            display: flex;
            flex-direction: column;
            gap: 0.55rem;
        }

        .HeroInputFull {
            grid-column: 1 / -1;
        }

        .FieldLabel {
            font-size: 0.9rem;
            font-weight: 700;
            color: #35556d;
            letter-spacing: 0.02em;
        }

        .FormCard {
            padding: 1.75rem;
            display: flex;
            flex-direction: column;
            gap: 1.4rem;
        }

        .SectionHeader {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            gap: 1rem;

            h2 {
                margin: 0.2rem 0 0;
                color: #21588C;
                font-size: 1.5rem;
            }

            p {
                margin: 0;
                max-width: 360px;
                color: #67808f;
                line-height: 1.6;
                font-size: 0.96rem;
            }
        }

        .CardGrid {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 1rem;
        }

        .FieldWide {
            grid-column: span 2;
        }

        .SliderStack {
            display: flex;
            flex-direction: column;
            gap: 2.2rem;
        }

        .SliderRow {
            display: grid;
            grid-template-columns: 1fr auto 1fr;
            gap: 1.5rem;
            align-items: stretch;
        }

        .SliderRowSingle {
            grid-template-columns: 1fr;
        }

        .SliderDivider {
            width: 1px;
            background: rgba(0, 0, 0, 0.12);
        }

        .SliderBlock {
            display: flex;
            flex-direction: column;
            gap: 0.9rem;
        }

        .SliderBlockCompact {
            .SliderLabel {
                font-size: 0.9rem;
            }

            .SliderValue {
                font-size: 0.85rem;
            }

            .rs-slider .rs-slider-bar .rs-slider-mark .rs-slider-mark-content {
                font-size: 13px;
            }
        }

        .SliderHeader {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 1rem;
        }

        .SliderLabel {
            color: #21588C;
            font-size: 1rem;
            font-weight: 700;
        }

        .SliderValue {
            color: #1c8d73;
            font-size: 0.95rem;
            font-weight: 700;
            text-align: right;
        }

        .SliderContainer {
            width: calc(100% - 0.5rem);
            align-self: center;
        }

        /* Enganche editable (monto exacto) */
        .EngancheValue {
            display: inline-flex;
            align-items: center;
            justify-content: flex-end;
            flex-wrap: wrap;
            gap: 0.35rem;
        }

        .EngancheAmount {
            border: 1.5px solid transparent;
            border-radius: 8px;
            padding: 0.1rem 0.35rem;
            transition: border-color 0.2s ease, color 0.2s ease;
        }

        .EngancheAmountError {
            border-color: #ff0000;
            color: #e74c3c;
        }

        .EngancheInputWrap {
            display: inline-flex;
            align-items: center;
            gap: 0.2rem;
            border: 1.5px solid #34C6F1;
            border-radius: 8px;
            padding: 0.15rem 0.5rem;
            background: #fff;
            box-shadow: 0 0 0 3px rgba(52, 198, 241, 0.18);
        }

        .EngancheInput {
            width: 8rem;
            border: none;
            outline: none;
            background: transparent;
            font: inherit;
            color: inherit;
            text-align: right;
        }

        .EngancheLink {
            align-self: flex-start;
            display: inline-flex;
            align-items: center;
            gap: 0.4rem;
            padding: 0;
            border: none;
            background: none;
            color: #21588C;
            font-size: 0.9rem;
            font-weight: 700;
            text-decoration: underline;
            text-underline-offset: 3px;
            cursor: pointer;

            &:hover {
                color: #34C6F1;
            }
        }

        .EngancheHint {
            color: #67808f;
            font-size: 0.82rem;
        }

        .EngancheAviso {
            display: flex;
            align-items: center;
            gap: 0.4rem;
            color: #e74c3c;
            font-size: 0.85rem;
            font-weight: 600;
        }

        .InsuranceWrapper {
            display: flex;
            flex-direction: column;
            gap: 0.8rem;
        }

        .SubmitRow {
            display: flex;
            justify-content: center;
            padding: 0.5rem 0 1rem;
        }

        .SubmitButton {
            width: 100%;
            max-width: 400px;
            font-size: 1.1rem;
            font-weight: 700;
            padding: 0.85rem 2rem;
            border-radius: 10px;
        }

        .Empty {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            font-size: 1rem;
            color: #5e6a72;
            padding: 1rem 0;
            text-align: center;
        }

        .SummaryColumn {
            position: sticky;
            top: 6.5rem;
            opacity: 0;
            transform: translateX(40px);
            pointer-events: none;
            transition: opacity 0.45s ease, transform 0.45s ease;
        }

        .SummaryColumnVisible {
            opacity: 1;
            transform: translateX(0);
            pointer-events: auto;
        }

        .PlazoCards {
            display: flex;
            gap: 0.5rem;
            justify-content: center;
        }

        .PlazoCard {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 0.1rem;
            padding: 0.6rem 0.4rem;
            border-radius: 14px;
            border: 2px solid #34C6F1;
            background: transparent;
            cursor: pointer;
            transition: all 0.2s ease;

            &:hover {
                background: rgba(52, 198, 241, 0.08);
            }
        }

        .PlazoCardActive {
            background: linear-gradient(135deg, #34C6F1, #00BA6E);
            border-color: transparent;

            .PlazoCardMonths,
            .PlazoCardLabel,
            .PlazoCardPrice {
                color: white;
            }

            &:hover {
                background: linear-gradient(135deg, #2bb4dd, #00a85f);
            }
        }

        .PlazoCardMonths {
            font-size: 1.3rem;
            font-weight: 700;
            color: #21588C;
            line-height: 1;
        }

        .PlazoCardLabel {
            font-size: 0.65rem;
            color: #67808f;
            text-transform: uppercase;
            letter-spacing: 0.06em;
            font-weight: 600;
        }

        .PlazoCardPrice {
            font-size: 0.7rem;
            color: #1c8d73;
            font-weight: 700;
            margin-top: 0.15rem;
        }

        .SummaryHighlightSub {
            color: #1c8d73;
            font-size: 0.85rem;
            font-weight: 600;
            text-align: center;
        }

        .SummaryDialog .p-dialog-content {
            border-radius: 28px;
        }

        .SummaryCard {
            overflow: hidden;
            display: flex;
            flex-direction: column;
        }

        .SummaryTop {
            padding: 1.6rem;
            display: flex;
            flex-direction: column;
            gap: 1.25rem;
        }

        .SummaryHeader {
            display: flex;
            flex-direction: column;
            gap: 0.4rem;

            h3 {
                margin: 0;
                color: #21588C;
                font-size: 1.45rem;
                line-height: 1.25;
            }
        }

        .SummaryList {
            display: flex;
            flex-direction: column;
            gap: 0.9rem;
        }

        .SummaryRow {
            display: flex;
            justify-content: space-between;
            gap: 1rem;
            color: #54707f;
            font-size: 0.97rem;

            strong {
                color: #193e61;
                text-align: right;
            }
        }

        .SummaryHighlight {
            border-radius: 24px;
            padding: 1.2rem;
            background: linear-gradient(135deg, rgba(52, 198, 241, 0.12), rgba(34, 236, 154, 0.16));
            display: flex;
            flex-direction: column;
            gap: 0.45rem;
        }

        .SummaryHighlightLabel {
            color: #35556d;
            font-size: 0.82rem;
            text-transform: uppercase;
            letter-spacing: 0.12em;
            font-weight: 700;
        }

        .SummaryHighlightValue {
            color: #0f4773;
            font-size: clamp(2rem, 1.2rem + 2vw, 3rem);
            line-height: 1;
        }

        .SummaryStep2Button {
            width: 100%;
            justify-content: center;
            padding: 0.7rem 1rem;
            margin-top: 0.5rem;
            font-size: 0.85rem;
            border-radius: 8px;
        }

        .SummaryContactForm {
            display: flex;
            flex-direction: column;
            gap: 0.55rem;
            margin-top: 0.8rem;
            padding-top: 0.8rem;
            border-top: 1px solid rgba(0, 0, 0, 0.08);
        }

        .SummaryContactLabel {
            font-size: 0.8rem;
            font-weight: 600;
            color: #21588c;
            text-transform: uppercase;
            letter-spacing: 0.04em;
        }

        .SummaryInput {
            width: 100%;
            font-size: 0.9rem;
            padding: 0.55rem 0.8rem;
            border-radius: 8px;
            border: 1px solid #d0d7de;
        }

        .SummarySendButton {
            width: 100%;
            justify-content: center;
            padding: 0.65rem 1rem;
            font-size: 0.85rem;
            border-radius: 8px;
        }

        .SummaryStatusSuccess {
            font-size: 0.8rem;
            color: #1fdd8f;
            font-weight: 600;
            text-align: center;
        }

        .SummaryStatusError {
            font-size: 0.8rem;
            color: #e74c3c;
            font-weight: 600;
            text-align: center;
        }

        .SummaryFooter {
            position: relative;
            min-height: 180px;
            padding: 1.4rem 1.6rem 1.8rem;
            background:
                radial-gradient(circle at top left, rgba(34, 236, 154, 0.22), transparent 44%),
                radial-gradient(circle at bottom right, rgba(52, 198, 241, 0.28), transparent 48%),
                linear-gradient(140deg, #173d5f, #21588C 58%, #22a37e 140%);
            color: white;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            gap: 0.55rem;
        }

        .SummaryVehicle {
            font-size: 1.45rem;
            font-weight: 700;
            line-height: 1.2;
        }

        .SummaryMeta {
            color: rgba(255, 255, 255, 0.82);
            line-height: 1.5;
        }

        .ButtonWithShadow {
            display: flex;
            flex-direction: column;
            width: fit-content;
            gap: 2rem;
        }

        .Green {
            background-color: #1FDD8F;
            color: white;
            font-size: calc(0.4rem + 0.7vw);
            border-radius: 17px !important;
            border: unset !important;

            :hover {
                background-color: #2ad690;
            }
        }

        .rs-slider {
            .rs-slider-bar {
                background: linear-gradient(90deg, #34C6F1 0%, #00BA6E 100%);
                height: 4px;

                .rs-slider-graduator > ol > li:before {
                    background-color: #00BA6E;
                    border: 2px solid #00BA6E;
                    width: 14px;
                    height: 14px;
                    margin-left: -8px;
                    top: -5px;
                }

                .rs-slider-graduator > ol > li:first-child:before {
                    background-color: #34C6F1;
                    border: 2px solid #34C6F1;
                }

                .rs-slider-graduator > ol > li:last-child:after {
                    background-color: #00BA6E;
                    border: 2px solid #00BA6E;
                    width: 14px;
                    height: 14px;
                    margin-left: -8px;
                    top: -5px;
                }

                .rs-slider-mark {
                    top: 20px;

                    .rs-slider-mark-content {
                        font-family: 'Neue Haas Grotesk Display Pro';
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 600;
                    }
                }
            }

            .rs-slider-handle {
                ::before {
                    background-color: #34C6F1;
                    border: 2px solid #34C6F1;
                    width: 24px;
                    height: 24px;
                    margin-left: -12px;
                    top: -8px;
                }
            }
        }

        .SliderError {
            .rs-slider-bar {
                background: linear-gradient(90deg, #ff7b7b 0%, #ff4d4d 100%);
            }
        }

        .Dropdown {
            background-color: transparent;
            border-radius: 17px;
            border-color: #34C6F1;
            border-width: 1.5px;
            width: 100%;

            .p-inputtext {
                padding: 1rem 1.4rem;
                letter-spacing: 0.46px;
            }

            input {
                background-color: transparent;
                width: 100%;
                padding: 1rem 1.4rem;
                font-family: 'Neue Haas Grotesk Display Pro' !important;
                font-style: normal;
                font-weight: 600;
                letter-spacing: 0.46px;
                color: black;
            }

            .p-placeholder {
                color: #A7A9AC;
                font-weight: 500;
            }

            * {
                font-family: 'Neue Haas Grotesk Display Pro' !important;
                font-size: calc(0.2rem + 0.7vw);

                @media (max-width: ${bpoints.tablet.w}px) {
                    font-size: calc(0.8rem + 1vw);
                }
            }
        }

        .DropdownError {
            background-color: transparent;
            border-radius: 17px;
            border-color: #ff0000;
            border-width: 1.5px;
            text-transform: uppercase;
            width: 100%;
            font-weight: 500;

            .p-inputtext {
                padding: 1rem 1.4rem;
                letter-spacing: 0.46px;
            }

            .p-placeholder {
                color: #A7A9AC;
                font-weight: 500;
            }

            * {
                font-family: 'Neue Haas Grotesk Display Pro' !important;
                font-size: calc(0.2rem + 0.7vw);

                @media (max-width: ${bpoints.tablet.w}px) {
                    font-size: calc(0.8rem + 1vw);
                }
            }
        }

        .TextInput,
        .TextInputError {
            background-color: transparent;
            border-radius: 17px;
            border-width: 1.5px;
            width: 100%;
            padding: 1rem 1.4rem;
            font-family: 'Neue Haas Grotesk Display Pro' !important;
            font-size: calc(0.2rem + 0.7vw);
            font-style: normal;
            font-weight: 600;
            letter-spacing: 0.46px;
            color: black;

            @media (max-width: ${bpoints.tablet.w}px) {
                font-size: calc(0.8rem + 1vw);
            }

            ::placeholder {
                font-weight: 500;
                color: #A7A9AC;
            }
        }

        .TextInput {
            border-color: #34C6F1;
        }

        .TextInputError {
            border-color: #ff0000;
        }

        @media (max-width: ${bpoints.tablet.w}px) {
            .LayoutShell {
                width: 92%;
            }

            .CardGrid {
                grid-template-columns: repeat(2, minmax(0, 1fr));
            }

            .FieldWide {
                grid-column: span 2;
            }

            .SectionHeader {
                flex-direction: column;

                p {
                    max-width: none;
                }
            }
        }

        @media (max-width: ${bpoints.mobile.w}px) {
            .MainContainer {
                padding-top: 1.5rem;
            }

            .HeroCard,
            .FormCard {
                padding: 1.3rem;
            }

            .HeroInputs,
            .CardGrid,
            .SliderRow {
                grid-template-columns: 1fr;
            }

            .SliderDivider {
                display: none;
            }

            .FieldWide {
                grid-column: span 1;
            }

            .SliderHeader {
                flex-direction: column;
                align-items: flex-start;
            }

            .rs-slider .rs-slider-bar .rs-slider-mark .rs-slider-mark-content {
                font-size: 13px;
            }

            .SummaryTop,
            .SummaryFooter {
                padding-left: 1.25rem;
                padding-right: 1.25rem;
            }

            .ResultsPanel {
                padding: 1.3rem;
            }

            .PlazoTabs {
                gap: 0.5rem;
            }

            .PlazoTab {
                padding: 0.6rem 0.8rem;
            }

            .ResultsTable {
                font-size: 0.72rem;

                th, td {
                    padding: 0.35rem 0.4rem;
                }
            }

            .ResultsFormInputs {
                grid-template-columns: 1fr;
            }

            .ResultsFormButtons {
                flex-direction: column;
            }
        }

        /* ---- Quote Results Panel ---- */

        .ResultsPanel {
            border-radius: 28px;
            background: rgba(255, 255, 255, 0.73);
            box-shadow: 2px 2px 11px rgba(33, 88, 140, 0.04);
            backdrop-filter: blur(5px);
            padding: 1.75rem;
            display: flex;
            flex-direction: column;
            gap: 1.5rem;
        }

        .ResultsHeader {
            display: flex;
            flex-direction: column;
            gap: 0.4rem;

            h2 {
                margin: 0.2rem 0 0;
                color: #21588C;
                font-size: 1.5rem;
            }
        }

        .ResultsVehicleLabel {
            color: #587183;
            font-size: 1rem;
            font-weight: 600;
        }

        .ResultsHighlight {
            border-radius: 24px;
            padding: 1.4rem;
            background: linear-gradient(135deg, rgba(52, 198, 241, 0.12), rgba(34, 236, 154, 0.16));
            display: flex;
            flex-direction: column;
            gap: 0.35rem;
            text-align: center;
        }

        .ResultsHighlightLabel {
            color: #35556d;
            font-size: 0.82rem;
            text-transform: uppercase;
            letter-spacing: 0.12em;
            font-weight: 700;
        }

        .ResultsHighlightValue {
            color: #0f4773;
            font-size: clamp(2rem, 1.2rem + 2vw, 3rem);
            line-height: 1;
            font-weight: 700;
        }

        .ResultsHighlightSub {
            color: #1c8d73;
            font-size: 0.9rem;
            font-weight: 600;
        }

        .PlazoTabs {
            display: flex;
            gap: 0.75rem;
            justify-content: center;
        }

        .PlazoTab {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 0.15rem;
            padding: 0.75rem 1.2rem;
            border-radius: 16px;
            border: 2px solid #34C6F1;
            background: transparent;
            cursor: pointer;
            transition: all 0.2s ease;

            &:hover {
                background: rgba(52, 198, 241, 0.08);
            }
        }

        .PlazoTabActive {
            background: linear-gradient(135deg, #34C6F1, #00BA6E);
            border-color: transparent;
            color: white;

            .PlazoTabMonths,
            .PlazoTabLabel {
                color: white;
            }

            &:hover {
                background: linear-gradient(135deg, #2bb4dd, #00a85f);
            }
        }

        .PlazoTabMonths {
            font-size: 1.4rem;
            font-weight: 700;
            color: #21588C;
            line-height: 1;
        }

        .PlazoTabLabel {
            font-size: 0.7rem;
            color: #67808f;
            text-transform: uppercase;
            letter-spacing: 0.08em;
            font-weight: 600;
        }

        .ResultsTableSection {
            display: flex;
            flex-direction: column;
            gap: 0.6rem;
        }

        .ResultsTableTitle {
            margin: 0;
            color: #21588C;
            font-size: 1.1rem;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.08em;
        }

        .ResultsTableWrapper {
            overflow-x: auto;
            border-radius: 16px;
            border: 1px solid rgba(52, 198, 241, 0.2);
        }

        .ResultsTable {
            width: 100%;
            border-collapse: collapse;
            font-size: 0.85rem;

            th, td {
                padding: 0.5rem 0.75rem;
                text-align: right;
                white-space: nowrap;
            }

            th {
                background: linear-gradient(135deg, #21588C, #1a6e9e);
                color: white;
                font-weight: 700;
                font-size: 0.8rem;
                text-transform: uppercase;
                letter-spacing: 0.06em;

                &:first-child {
                    text-align: left;
                }
            }

            td {
                color: #193e61;
                border-bottom: 1px solid rgba(52, 198, 241, 0.1);

                &:first-child {
                    text-align: left;
                    color: #54707f;
                    font-weight: 600;
                }
            }

            tbody tr:hover {
                background: rgba(52, 198, 241, 0.04);
            }
        }

        .ResultsRowTotal {
            td {
                font-weight: 700 !important;
                color: #0f4773 !important;
                border-top: 2px solid rgba(52, 198, 241, 0.3);
                background: rgba(52, 198, 241, 0.06);
            }
        }

        .ResultsRowIva {
            td {
                border-bottom: 2px solid rgba(52, 198, 241, 0.2);
            }
        }

        .ResultsResidual {
            text-align: center;
            color: #1c8d73;
            font-weight: 700;
            font-size: 1rem;
            padding: 0.75rem;
            border-radius: 16px;
            background: rgba(34, 236, 154, 0.08);
        }

        .ResultsNotes {
            padding: 1rem 1.25rem;
            border-radius: 16px;
            background: rgba(33, 88, 140, 0.04);
            color: #54707f;
            font-size: 0.92rem;
            line-height: 1.6;

            p {
                margin: 0 0 0.5rem;
                color: #21588C;
            }

            ul {
                margin: 0;
                padding-left: 1.25rem;
            }

            li {
                margin-bottom: 0.25rem;
            }
        }

        .ResultsActions {
            display: flex;
            flex-direction: column;
            gap: 1.25rem;
        }

        .ResultsActionButton {
            border-radius: 17px !important;
            border: unset !important;
            padding: 0.85rem 1.4rem;
            font-weight: 700;
            font-size: 0.95rem;
        }

        .Blue {
            background-color: #21588C;
            color: white;

            &:hover {
                background-color: #1a4a78;
            }
        }

        .ResultsForm {
            display: flex;
            flex-direction: column;
            gap: 1rem;
        }

        .ResultsFormLabel {
            margin: 0;
            color: #35556d;
            font-size: 0.95rem;
            font-weight: 600;
        }

        .ResultsFormInputs {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 0.75rem;
        }

        .ResultsFormButtons {
            display: flex;
            gap: 0.75rem;
            flex-wrap: wrap;

            .ResultsActionButton {
                flex: 1;
                min-width: 200px;
                justify-content: center;
            }
        }
    `;
}
